module.exports = __webpack_public_path__ + "img/cover-minigame-bg.b0026073.png";